import { Card, Header } from '@breward/ui';
import { useTranslation } from 'react-i18next';
import { BeerGuidelines } from '../types';

interface SensorySummaryCardProps {
    gl?: BeerGuidelines;
}

export const SensorySummaryCard = ({ gl }: SensorySummaryCardProps) => {
    const [t] = useTranslation();

    return (
        <Card className="p-5">
            <div className="col-span-12 flex flex-col gap-4">
                <Header
                    variant="card"
                    title={t('Pages:ParticipantWeb.ShowStylePage.SensorySummary.title', 'Podsumowanie profilu')}
                />
                <div className="divide-y divide-solid divide-primary-100/50 dark:divide-primary-900/20 text-xs font-sans">
                    <div className="py-2 flex justify-between gap-4">
                        <span className="text-primary-500 font-semibold">{t('Pages:ParticipantWeb.ShowStylePage.SensorySummary.appearance', 'Wygląd')}</span>
                        <span className="text-primary-800 dark:text-primary-200 text-right">{gl?.appearanceHighlight || '-'}</span>
                    </div>
                    <div className="py-2 flex justify-between gap-4">
                        <span className="text-primary-500 font-semibold">{t('Pages:ParticipantWeb.ShowStylePage.SensorySummary.aroma', 'Aromat')}</span>
                        <span className="text-primary-800 dark:text-primary-200 text-right">{gl?.aromaHighlight || '-'}</span>
                    </div>
                    <div className="py-2 flex justify-between gap-4">
                        <span className="text-primary-500 font-semibold">{t('Pages:ParticipantWeb.ShowStylePage.SensorySummary.flavor', 'Smak')}</span>
                        <span className="text-primary-800 dark:text-primary-200 text-right">{gl?.flavorHighlight || '-'}</span>
                    </div>
                    <div className="py-2 flex justify-between gap-4">
                        <span className="text-primary-500 font-semibold">{t('Pages:ParticipantWeb.ShowStylePage.SensorySummary.bitterness', 'Goryczka')}</span>
                        <span className="text-primary-800 dark:text-primary-200 text-right">{gl?.bitternessHighlight || '-'}</span>
                    </div>
                    <div className="py-2 flex justify-between gap-4">
                        <span className="text-primary-500 font-semibold">{t('Pages:ParticipantWeb.ShowStylePage.SensorySummary.mouthfeel', 'Odczucie')}</span>
                        <span className="text-primary-800 dark:text-primary-200 text-right">{gl?.mouthfeelHighlight || '-'}</span>
                    </div>
                    <div className="py-2 flex justify-between gap-4">
                        <span className="text-primary-500 font-semibold">{t('Pages:ParticipantWeb.ShowStylePage.SensorySummary.comments', 'Komentarz')}</span>
                        <span className="text-primary-800 dark:text-primary-200 text-right">{gl?.commentsHighlight || '-'}</span>
                    </div>
                </div>
            </div>
        </Card>
    );
};
